/**
 * Shared verse catalog for deck building.
 * Mechanics live in Proclaim; this is identity + Scripture + deck UI blurbs.
 */

import { STARTER_OWNED_IDS } from "../collection/starter";

export interface CatalogVerse {
  id: string;
  reference: string;
  textKjv: string;
  category: string;
  /** Short player-facing blurb for the deck UI */
  blurb: string;
}

/** All verses available to pick for Proclaim. */
export const CATALOG: CatalogVerse[] = [
  {
    id: "heb-11-1",
    reference: "Hebrews 11:1",
    textKjv:
      "Now faith is the substance of things hoped for, the evidence of things not seen.",
    category: "faith",
    blurb: "Broad Faith Answer — meets Fear & Despair.",
  },
  {
    id: "mark-11-22",
    reference: "Mark 11:22",
    textKjv: "And Jesus answering saith unto them, Have faith in God.",
    category: "faith",
    blurb: "Micro snipe — innermost; aim can full-clear Fear.",
  },
  {
    id: "rom-10-17",
    reference: "Romans 10:17",
    textKjv: "So then faith cometh by hearing, and hearing by the word of God.",
    category: "faith",
    blurb: "Soften −1 one lie (Redeem setup).",
  },
  {
    id: "ps-56-3",
    reference: "Psalm 56:3",
    textKjv: "What time I am afraid, I will trust in thee.",
    category: "faith",
    blurb: "Micro snipe + Still — trust under fear.",
  },
  {
    id: "phil-4-6-7",
    reference: "Philippians 4:6-7",
    textKjv:
      "Be careful for nothing; but in every thing by prayer and supplication with thanksgiving let your requests be made known unto God. And the peace of God, which passeth all understanding, shall keep your hearts and minds through Christ Jesus.",
    category: "peace",
    blurb: "Peace defense / Guard Prayer.",
  },
  {
    id: "john-14-27",
    reference: "John 14:27",
    textKjv:
      "Peace I leave with you, my peace I give unto you: not as the world giveth, give I unto you. Let not your heart be troubled, neither let it be afraid.",
    category: "peace",
    blurb: "Layer chip + Still the row.",
  },
  {
    id: "2cor-10-5",
    reference: "2 Corinthians 10:5",
    textKjv:
      "Casting down imaginations, and every high thing that exalteth itself against the knowledge of God, and bringing into captivity every thought to the obedience of Christ.",
    category: "faith",
    blurb: "Mind-only layer chip — every thought.",
  },
  {
    id: "col-3-15",
    reference: "Colossians 3:15",
    textKjv:
      "And let the peace of God rule in your hearts, to the which also ye are called in one body; and be ye thankful.",
    category: "peace",
    blurb: "Heart chip + mild Still.",
  },
  {
    id: "eph-6-16",
    reference: "Ephesians 6:16",
    textKjv:
      "Above all, taking the shield of faith, wherewith ye shall be able to quench all the fiery darts of the wicked.",
    category: "faith",
    blurb: "Layer chip vs Fear only.",
  },
  {
    id: "isa-26-3",
    reference: "Isaiah 26:3",
    textKjv:
      "Thou wilt keep him in perfect peace, whose mind is stayed on thee: because he trusteth in thee.",
    category: "peace",
    blurb: "Still + Refine / Mind ward.",
  },
  {
    id: "rom-15-13",
    reference: "Romans 15:13",
    textKjv:
      "Now the God of hope fill you with all joy and peace in believing, that ye may abound in hope, through the power of the Holy Ghost.",
    category: "peace",
    blurb: "Standard Answer — Despair/Fear + tilt.",
  },
  {
    id: "prov-3-6",
    reference: "Proverbs 3:6",
    textKjv:
      "In all thy ways acknowledge him, and he shall direct thy paths.",
    category: "faith",
    blurb: "Path Prayer — contests the layer ahead.",
  },
  {
    id: "thess-5-17",
    reference: "1 Thessalonians 5:17",
    textKjv: "Pray without ceasing.",
    category: "peace",
    blurb: "Restore a damaged Prayer to full.",
  },
  {
    id: "eccl-4-9-10",
    reference: "Ecclesiastes 4:9-10",
    textKjv:
      "Two are better than one; because they have a good reward for their labour. For if they fall, the one will lift up his fellow: but woe to him that is alone when he falleth; for he hath not another to help him up.",
    category: "peace",
    blurb: "Gather residual Prayers into one keep.",
  },
  {
    id: "neh-8-10",
    reference: "Nehemiah 8:10",
    textKjv: "...for the joy of the Lord is your strength.",
    category: "peace",
    blurb: "Joy: slowly wear down all Fear lies.",
  },
  {
    id: "ps-46-10",
    reference: "Psalm 46:10",
    textKjv: "Be still, and know that I am God...",
    category: "peace",
    blurb: "Still a whole layer.",
  },
  {
    id: "mark-4-39",
    reference: "Mark 4:39",
    textKjv:
      "And he arose, and rebuked the wind, and said unto the sea, Peace, be still. And the wind ceased, and there was a great calm.",
    category: "peace",
    blurb: "Still one lie + light Proclaim.",
  },
  {
    id: "gen-50-20",
    reference: "Genesis 50:20",
    textKjv:
      "But as for you, ye thought evil against me; but God meant it unto good, to bring to pass, as it is this day, to save much people alive.",
    category: "faith",
    blurb: "Redeem a lie into Prayer.",
  },
  {
    id: "rom-8-28",
    reference: "Romans 8:28",
    textKjv:
      "And we know that all things work together for good to them that love God...",
    category: "faith",
    blurb: "Cheaper Redeem.",
  },
  {
    id: "mark-11-23-24",
    reference: "Mark 11:23-24",
    textKjv:
      "For verily I say unto you, That whosoever shall say unto this mountain, Be thou removed, and be thou cast into the sea; and shall not doubt in his heart, but shall believe that those things which he saith shall come to pass; he shall have whatsoever he saith. Therefore I say unto you, What things soever ye desire, when ye pray, believe that ye receive them, and ye shall have them.",
    category: "faith",
    blurb: "Empower next Answer/Chip +1.",
  },
  {
    id: "eph-6-17",
    reference: "Ephesians 6:17",
    textKjv:
      "And take the helmet of salvation, and the sword of the Spirit, which is the word of God:",
    category: "faith",
    blurb: "Broad sword Answer — meets Fear & Despair.",
  },
  {
    id: "isa-40-31",
    reference: "Isaiah 40:31",
    textKjv:
      "But they that wait upon the Lord shall renew their strength; they shall mount up with wings as eagles; they shall run, and not be weary; and they shall walk, and not faint.",
    category: "peace",
    blurb: "Renew: restore Keep, half wear, ease neighbors.",
  },
  {
    id: "ps-91-1-2",
    reference: "Psalm 91:1-2",
    textKjv:
      "He that dwelleth in the secret place of the most High shall abide under the shadow of the Almighty. I will say of the Lord, He is my refuge and my fortress: my God; in him will I trust.",
    category: "peace",
    blurb: "Will Refuge Abide — Integrity regen.",
  },
  {
    id: "jas-1-5",
    reference: "James 1:5",
    textKjv:
      "If any of you lack wisdom, let him ask of God, that giveth to all men liberally, and upbraideth not; and it shall be given him.",
    category: "wisdom",
    blurb: "Wisdom snipe — Name Dogma, meet Doubt.",
  },
  {
    id: "jas-3-16-17",
    reference: "James 3:16-17",
    textKjv:
      "For where envying and strife is, there is confusion and every evil work. But the wisdom that is from above is first pure, then peaceable, gentle, and easy to be intreated, full of mercy and good fruits, without partiality, and without hypocrisy.",
    category: "wisdom",
    blurb: "Wipe all Confusion; Cast down a Dogma core.",
  },
  {
    id: "1cor-14-33",
    reference: "1 Corinthians 14:33",
    textKjv:
      "For God is not the author of confusion, but of peace, as in all churches of the saints.",
    category: "wisdom",
    blurb: "Shorter wipe — every Confusion falls silent.",
  },
  {
    id: "col-2-8",
    reference: "Colossians 2:8",
    textKjv:
      "Beware lest any man spoil you through philosophy and vain deceit, after the tradition of men, after the rudiments of the world, and not after Christ.",
    category: "wisdom",
    blurb: "Lay aside a brick; Cast down a Dogma core.",
  },
];

const byId = new Map(CATALOG.map((v) => [v.id, v]));

/**
 * Legacy verse ids remapped when loading collection / deck saves.
 * Drop entries once all active saves are past the rename.
 */
export const VERSE_ID_ALIASES: Readonly<Record<string, string>> = {
  "prov-3-5-6": "prov-3-6",
};

/** Resolve a possibly-legacy verse id to the current catalog id. */
export function resolveVerseId(id: string): string {
  return VERSE_ID_ALIASES[id] ?? id;
}

export function catalogById(id: string): CatalogVerse | undefined {
  return byId.get(resolveVerseId(id));
}

/**
 * Default / starter loadout for endless (owned at start).
 * Kept in sync with the shared collection starter pack.
 */
export const DEFAULT_DECK_IDS: string[] = [...STARTER_OWNED_IDS];

/**
 * Loadout size bounds.
 * DECK_MIN matches the starter pack (6) so a new player can always save
 * their starter loadout. Cap still grows with collection size (see max).
 */
export const DECK_MIN = STARTER_OWNED_IDS.length; // 6
export const DECK_MAX = 18;

/** Min deck size: never more than you own, never more than DECK_MIN. */
export function effectiveDeckMin(uniqueOwned: number): number {
  if (uniqueOwned <= 0) return DECK_MIN;
  return Math.min(DECK_MIN, uniqueOwned);
}

/** Max deck size cannot exceed unique owned (unique selection model). */
export function effectiveDeckMax(uniqueOwned: number): number {
  if (uniqueOwned <= 0) return DECK_MIN;
  return Math.min(DECK_MAX, uniqueOwned);
}
